import React, { useState, useEffect } from 'react';
import { actionsType, consumer, ecommerce } from 'config/constants';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import FilterService from 'services/Filter/';
import Metas from 'components/Metas';
import PubSub from "services/PubSub/";
import Shelf from 'components/Shelf'
import Loader from 'components/Loader'
import productsStore from 'stores/new/Products'
import ShelfHeader from 'components/ShelfHeader'
import BannerShelf from 'components/BannerShelf'
import productAction from 'actions/Product'
import { cleanFacet} from 'utils/index'
import SuggestionsTags from 'components/SuggestionsTags';
import { suggestionsTagsID } from 'config';
import useVariant  from 'hooks/useVariant';
import style from './style.scss';//NOSONAR

let _isMounted = false;
let filterService = null;
let filters = null;
let location = null;
let actions = [];

const Search = (props) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTermCorrection, setsearchTermCorrection] = useState('');
    const [products, setProducts] = useState([]);
    const [quantity, setQuantity] = useState(0);
    const [resultSimilares, setResultSimilares] = useState();
    const { store }  = props;

    const variant = useVariant(suggestionsTagsID);
    const newVariant = variant === '1' && consumer.includes('jumbo');

    useEffect(() => {
        let prods = (store && store.products) ? store.products.get('search') : null;

        if(prods && prods.toList){
            prods = prods.toList().toArray();
            setProducts(prods);
        }else{
            setProducts([]);
        }
    },[store])

    useEffect(() => {
        _isMounted = true;
        _changeProps(props);

        getContent();

        return () => {
            _isMounted = false;
        };
    }, []);

    useEffect(()=> {
        actions.push(PubSub.register(actionsType.CATALOG_CHANGE_PROPS, _catalogChangeProps))
        actions.push(PubSub.register(actionsType.SET_SALES_CHANNEL, () => getContent()));

        return () => {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    });

    useEffect(() => {
        const pathname = props.location.pathname;
        const search = props.location.search;
        const prevPathname = location.pathname;
        const prevSearch = location.search;
        const searchParsed = queryString.parse(search);
        const prevSearchParsed = queryString.parse(prevSearch);

        if (pathname !== prevPathname || (prevSearch !== '' && search === '') || (searchParsed.ft && searchParsed.ft !== prevSearchParsed.ft) || (searchParsed.b && searchParsed.b !== prevSearchParsed.b) || (search !== prevSearch)) {
            _changeProps(props);

            getContent();
        }

        location = props.location;
    }, [props.location]);

    const _catalogChangeProps = (payload) => {
        if(!payload.value) return false;
        _changeProps(payload.value)
    }

    const _changeProps = (newProps) => {
        location = newProps.location;
        filterService = new FilterService(newProps);
    };

    const getContent = () => {
        if(isLoaded){
            setIsLoaded(false);
        }
        const { search } = filterService;
        const queryString = props.location.search;
        const params = props.match.params;

        setSearchTerm(search);
        setsearchTermCorrection(search);

        productAction.getSearchFacets(search, params, queryString).then(data => {
            if(!_isMounted) return false;
            if(!(data && (data.Brands || data.SpecificationFilters))) {
                setIsLoaded(true);
                return false;
            }

            filters = {
                brands: data.Brands,
                filtersSearch: data.SpecificationFilters,
                categories: _getCategories(data.CategoriesTrees, params)
            };

            if(filters.categories && filters.categories.length > 1){
                filters.categories = [
                    {
                        id: 0,
                        items: filters.categories,
                        name: 'Departaments',
                        url: '',
                        key: 'category-0'
                    }
                ];
            }

            applyInitialFilters();

            setIsLoaded(true);
        });
    }

    const _getCategories = (categories, params) => {
        categories = params.category1 ? categories.map(departament => {
            if(departament.Link.indexOf(params.category1) !== -1){
                if(params.category2 && departament.Children && departament.Children[0]){
                    departament.Children = departament.Children.map(category => {
                        if(category.Link.indexOf(params.category2) !== -1){
                            if(params.category3 && category.Children && category.Children[0]){
                                category.Children = category.Children.filter(subcategory => subcategory.Link.indexOf(params.category3) !== -1)
                            }
                            return category;
                        } else {
                            return false;
                        }
                    }).filter(Boolean);
                }
                return departament;
            } else {
                return false;
            }
        }).filter(Boolean) : categories;

        if(params.category2){
            categories = categories[0].Children;

            if(params.category3){
                categories = categories[0].Children;
            }
        }

        return _fixCategories(categories);
    }

    const _fixCategories = (categoriesData, withParams = true) => {
        const params = window.location.search;

        return categoriesData ? categoriesData.map((itemCategory) => {
            return {
                id: itemCategory.Id,
                items: itemCategory.Children ? _fixCategories(itemCategory.Children, withParams) : [],
                name: itemCategory.Name,
                url: '/busqueda' + itemCategory.Link + (withParams ? params : '')
            }
        }) : [];
    }

    const applyInitialFilters = () => {
        const { brands } = filterService;
        const specificationsData = filterService.specifications;
        brands.map((brand) => {
            filters.brands
                .map((item) => item.active = (item.active || (cleanFacet(item.Name.toLowerCase()) === brand.toLowerCase())));
        });

        specificationsData.map(specification => {
            if(!filters.filtersSearch[specification.id]) return specification
            filters.filtersSearch[specification.id] = filters.filtersSearch[specification.id].map((itemFilter) => {
                itemFilter.active = itemFilter.active || (itemFilter.Name === specification.slug)
                return itemFilter;
            })
        });
    }

    const changeQuantity = (value) => {
        setQuantity(value);
    }

    const similarResponse = (data) => {
        setsearchTermCorrection(data && data.correction && data.correction.correction && data.correction.correction.text);
        setResultSimilares(data)
    }

    const title = "Búsqueda: " + searchTermCorrection;

    return (
        <div className="catalog-page page">
            {isLoaded && <Metas>
                <title>{title} | {ecommerce.metaTitle}</title>
            </Metas>}
            <div className="container">
                {!isLoaded && <div className="catalog-page-loader">
                    <Loader />
                </div>}
                {isLoaded && <div className="catalog-page-content">
                    <main className="shelf-main">
                        <BannerShelf location={location}/>
                        {newVariant && <SuggestionsTags searchTerm={searchTermCorrection} history={props.history}/>}
                        <ShelfHeader title={title} quantity={quantity} filter={filterService} filters={filters} specifications={null} searchWord={searchTerm} correction={resultSimilares}/>
                        <Shelf location={props.location} title={title} filter={filterService} products={products} searchTerm={searchTermCorrection} filters={filters} changeQuantity={changeQuantity} callbackData={similarResponse}/>
                    </main>
                </div>}
            </div>
        </div>
    )
}

Search.propTypes = {
    history: PropTypes.object,
    location: PropTypes.object
};

export default productsStore.wrapConsumer(Search);
